import { userIsAdmin, userIsAccountant, userIsSocio, userIsOficina } from '../context/AuthContext';

/**
 * A DÓNDE ENTRA CADA ROL. Una sola definición para el router (App.jsx) y para el login.
 *
 * VNA-127 — Estaba escrita DOS veces: `getDefaultRoute` en App.jsx y una copia más corta en
 * `LoginPage.handleSuccess`. Un rol enumerado en una y no en la otra entraba a un lado al
 * recargar y a otro al iniciar sesión (lo destapó Oficina: App decía /employee y el login
 * seguía mandando a /dashboard).
 */
export function getDefaultRoute(user) {
  if (userIsAdmin(user))       return '/admin';
  if (userIsAccountant(user))  return '/contabilidad';
  // ⚠⚠ V61 — EL SOCIO ESTÁ ENUMERADO A PROPÓSITO AUNQUE DEVUELVA EL MISMO DESTINO QUE EL
  // FALLBACK. La rama existe para que el rol NO caiga por descarte: cayendo, el sidebar lo
  // etiquetaba "Chofer" y nadie podía distinguir "decidimos mandarlo acá" de "nos olvidamos
  // de enumerarlo" — que es exactamente cómo se descubrió este hueco.
  //
  // ⚠ NO apunta a '/vacaciones', y no es un olvido: esa ruta SÍ renderiza (`AuthRequired`,
  // solo el botón del sidebar está deshabilitado), pero el módulo es WIP y sus pantallas
  // todavía llaman endpoints que ya no existen: `/vacation/supervisors` (retirado en V60,
  // RequestCreatePage:50) y `/api/vacation/balances` (retirado en V62 con `pto_balances`,
  // RequestListPage:27 y RequestCreatePage:49). Mandarlo ahí hoy sería aterrizar en errores.
  // ⚠ Esas dos llamadas se van con la reescritura de esas pantallas, en el COMMIT 2 de V62;
  // hasta entonces no hacen daño porque el módulo está bloqueado y nadie las alcanza.
  // **Cambiar esta línea por `return '/vacaciones';`** cuando el módulo se destrabe.
  if (userIsSocio(user))       return '/dashboard';
  // VNA-127 — Oficina entra a Mis Recibos, como el chofer: es lo que hace a diario, y su
  // Dashboard solo tiene la pestaña de Gastos. Enumerado para no caer por descarte (V61).
  if (userIsOficina(user))     return '/employee';
  return '/dashboard';
}
